// Reusable JSON-LD schema builders shared across generator pages, occasion pages and the
// blog, so every new page stays structurally consistent (schema.org compliant) without
// hand-rolling the same boilerplate each time. Rating figures are kept in sync with the
// aggregateRating shown on /avis (ReviewsPage.jsx) to avoid inconsistent ratings across pages.
export const SITE_RATING = { ratingValue: "4.9", reviewCount: 111 };

// Profils sociaux officiels Kalypso Music (GEO : cohérence marque + sameAs Organization).
export const SOCIAL_PROFILES = [
  { id: "youtube", label: "YouTube", url: "https://www.youtube.com/@kalypsomusic-y7h" },
  { id: "facebook", label: "Facebook", url: "https://www.facebook.com/share/19vRTYUure/" },
  { id: "instagram", label: "Instagram", url: "https://www.instagram.com/kalypsomusic7" },
  { id: "tiktok", label: "TikTok", url: "https://www.tiktok.com/@kalypso.music5" },
];

export function buildOrganizationSchema(siteUrl, description) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${siteUrl}/#organization`,
    name: "Kalypso Music",
    url: siteUrl,
    logo: { "@type": "ImageObject", url: `${siteUrl}/icon-512.png` },
    description,
    sameAs: SOCIAL_PROFILES.map((p) => p.url),
  };
}

export function buildWebSiteSchema(siteUrl) {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${siteUrl}/#website`,
    name: "Kalypso Music",
    alternateName: "kalypsomusic.com",
    url: siteUrl,
    inLanguage: ["fr", "en"],
    publisher: { "@id": `${siteUrl}/#organization` },
  };
}

export function buildBreadcrumbSchema(items, siteUrl) {
  // items: [{ name: "Accueil", path: "/" }, { name: "Générateurs IA", path: "/fr" }, ...]
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: `${siteUrl}${item.path}`,
    })),
  };
}

export function buildFAQSchema(faqList) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };
}

export function buildSoftwareApplicationSchema({ name, description, url }) {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name,
    description,
    url,
    applicationCategory: "MusicApplication",
    operatingSystem: "Web, Android",
    offers: {
      "@type": "AggregateOffer",
      priceCurrency: "EUR",
      lowPrice: "9",
      highPrice: "49",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: SITE_RATING.ratingValue,
      reviewCount: SITE_RATING.reviewCount,
      bestRating: "5",
    },
  };
}

export function buildArticleSchema({ headline, description, url, image, datePublished, dateModified, authorName = "Kalypso Music" }) {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline,
    description,
    image,
    datePublished,
    dateModified: dateModified || datePublished,
    author: { "@type": "Organization", name: authorName },
    publisher: {
      "@type": "Organization",
      name: "Kalypso Music",
      logo: { "@type": "ImageObject", url: `${url.split("/blog")[0]}/icon-512.png` },
    },
    mainEntityOfPage: { "@type": "WebPage", "@id": url },
  };
}
